import React, { Component } from "react";

// MetisMenu
import MetisMenu from "metismenujs";
import { withRouter } from "react-router-dom";
import { Link } from "react-router-dom";

//i18n
import { withNamespaces } from "react-i18next";

import { connect } from "react-redux";
import {
  changeLayout,
  changeLayoutWidth,
  changeSidebarTheme,
  changeSidebarType,
  changePreloader,
} from "../../store/actions";

class SidebarContent extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.initMenu();
  }

  componentDidUpdate(prevProps) {
    if (prevProps !== this.props) {
      if (this.props.type !== prevProps.type) {
        this.initMenu();
      }
    }
  }

  initMenu() {
    new MetisMenu("#side-menu");

    var matchingMenuItem = null;
    var ul = document.getElementById("side-menu");
    var items = ul.getElementsByTagName("a");
    for (var i = 0; i < items.length; ++i) {
      if (this.props.location.pathname === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      this.activateParentDropdown(matchingMenuItem);
    }
  }

  activateParentDropdown = (item) => {
    item.classList.add("active");
    const parent = item.parentElement;

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show");

        const parent3 = parent2.parentElement;

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement;
          if (parent4) {
            parent4.classList.add("mm-active");
          }
        }
      }
      return false;
    }
    return false;
  };

  render() {
    const user = this.props.user;
    console.log("props", user);
    return (
      <React.Fragment>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li>
              <Link to="/dashboard" className="waves-effect">
                <i className="ri-dashboard-line"></i>
                {/* <span className="badge rounded-pill bg-success float-end">
                  3
                </span> */}
                <span className="ms-1">{this.props.t("Dashboard")}</span>
              </Link>
            </li>
            {user?.role?.title == "Admin" && (
              <li>
                <Link to="/#" className="has-arrow waves-effect">
                  <i className="ri-window-line"></i>
                  <span className="ms-1">{this.props.t("Website Pages")}</span>
                </Link>
                <ul className="sub-menu">
                  <li>
                    <Link to="/homepage">{this.props.t("Home")}</Link>
                  </li>
                  <li>
                    <Link to="/aboutus">{this.props.t("About Us")}</Link>
                  </li>
                  <li>
                    <Link to="/privacy">{this.props.t("Privacy Policy")}</Link>
                  </li>
                  <li>
                    <Link to="/terms">
                      {this.props.t("Data Security Policy")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/contactus">{this.props.t("Contact Us")}</Link>
                  </li>
                  <li>
                    <Link to="/career">{this.props.t("Careers")}</Link>
                  </li>
                  <li>
                    <Link to="/talktous">
                      {this.props.t("Talk To Us Page")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/faq">{this.props.t("FAQ")}</Link>
                  </li>
                  <li>
                    <Link to="/downloads">
                      {this.props.t("Downloads Page")}
                    </Link>
                  </li>
                  <li>
                    <Link to="/social">{this.props.t("Social News")}</Link>
                  </li>
                  <li>
                    <Link to="/common">{this.props.t("Common")}</Link>
                  </li>
                </ul>
              </li>
            )}
            {user?.role?.title == "Admin" && (
              <>
                <li>
                  <Link to="/events" className="waves-effect">
                    <i className="ri-calendar-check-line"></i>
                    <span className="ms-1">{this.props.t("Events")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/stats" className="waves-effect">
                    <i className="ri-line-chart-line"></i>
                    <span className="ms-1">
                      {this.props.t("Company Stats")}
                    </span>
                  </Link>
                </li>
                <li>
                  <Link to="/team" className="waves-effect">
                    <i className="ri-team-line"></i>
                    <span className="ms-1">{this.props.t("Team")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/customers" className="waves-effect">
                    <i className="ri-user-star-fill"></i>
                    <span className="ms-1">{this.props.t("Customers")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/roles" className="waves-effect">
                    <i className="ri-shield-user-line"></i>
                    <span className="ms-1">{this.props.t("Roles")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/staff" className="waves-effect">
                    <i className="ri-user-2-line"></i>
                    <span className="ms-1">{this.props.t("Staff")}</span>
                  </Link>
                </li>
              </>
            )}

            <li>
              <Link to="/tools" className="waves-effect">
                <i className="ri-tools-line"></i>
                <span className="ms-1">{this.props.t("Tools")}</span>
              </Link>
            </li>

            {user?.role?.title == "Admin" && (
              <>
                <li>
                  <Link to="/enquiries" className="waves-effect">
                    <i className="ri-contacts-book-line"></i>
                    <span className="ms-1">{this.props.t("Enquiries")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/general-enquiries" className="waves-effect">
                    <i className="ri-contacts-book-line"></i>
                    <span className="ms-1">
                      {this.props.t("General Enquiries")}
                    </span>
                  </Link>
                </li>

                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ri-file-list-2-line"></i>
                    <span className="ms-1">{this.props.t("Features")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/features">{this.props.t("Features")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ri-archive-drawer-line"></i>
                    <span className="ms-1">{this.props.t("Solutions")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/solutions">{this.props.t("Solutions")}</Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ri-download-2-line"></i>
                    <span className="ms-1">{this.props.t("Downloads")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/downloads/category">
                        {this.props.t("Categories")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/downloads/list">
                        {this.props.t("Downloads")}
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* Social news */}
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ri-newspaper-line"></i>
                    <span className="ms-1">{this.props.t("Social News")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/social/category">
                        {this.props.t("Categories")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/social/list">
                        {this.props.t("Social News")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/#" className="has-arrow waves-effect">
                    <i className="ri-briefcase-line"></i>
                    <span className="ms-1">{this.props.t("Jobs")}</span>
                  </Link>
                  <ul className="sub-menu">
                    <li>
                      <Link to="/jobs/category">
                        {this.props.t("Categories")}
                      </Link>
                    </li>
                    <li>
                      <Link to="/jobs">{this.props.t("Job List")}</Link>
                    </li>
                    <li>
                      <Link to="/jobs/applications">
                        {this.props.t("Job Application")}
                      </Link>
                    </li>
                  </ul>
                </li>
                <li>
                  <Link to="/settings" className="waves-effect">
                    <i className="ri-settings-3-line"></i>
                    <span className="ms-1">{this.props.t("Settings")}</span>
                  </Link>
                </li>
              </>
            )}
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

const mapStatetoProps = (state) => {
  return { ...state.Layout, user: state.User.user };
};

export default withRouter(
  connect(mapStatetoProps, {
    changeLayout,
    changeSidebarTheme,
    changeSidebarType,
    changeLayoutWidth,
    changePreloader,
  })(withNamespaces()(SidebarContent))
);
